import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { authApi, useAuth } from "./AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = hash.split("session_id=")[1]?.split("&")[0];
    if (!sid) { navigate("/investor"); return; }
    (async () => {
      try {
        const res = await authApi.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(res.data);
        try { localStorage.setItem("n3_session", "1"); } catch (e) { /* ignore */ }
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate(res.data.role === "admin" ? "/admin" : "/investor/dashboard", { replace: true });
      } catch (e) {
        navigate("/investor", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy-950">
      <div className="text-center">
        <Loader2 className="mx-auto h-8 w-8 text-primary animate-spin" />
        <p className="mt-4 text-sm text-muted-foreground">Securing your session…</p>
      </div>
    </div>
  );
}
